// QR Kiosk — date pattern per UI language (USER-LANG-IT-PL-1 L5).
// The kiosk renders every date through a FIXED moment pattern ("DD.MM.YYYY", "DD.MM.YYYY, HH:mm")
// rather than a locale token: the moment `en` locale's "L" is MM/DD/YYYY and `cs` is "D. M. YYYY",
// so switching to locale tokens would silently change what en/cs users see today.
// Glossary LANGUAGES_GLOSSARY_IT_DE_PL.md §5: de and pl write dd.mm.yyyy (unchanged), Italian writes
// dd/mm/yyyy (matches the dayjs/moment `it` locale and the live landing). Only the date part
// changes; the time part stays HH:mm (24 h) in every language. Pure, no React — callers pass
// `i18n.language` from useTranslation(), which re-renders them on `languageChanged`.
export function localizeDateFormat(format: string, lng?: string | null): string {
  return (lng || "").split("-")[0] === "it" ? format.replace(/DD\.MM\.YYYY/g, "DD/MM/YYYY") : format;
}

export default localizeDateFormat;
